import {useMemo} from 'react';

import {useIsMobile} from '../../../util/panelbankFlow';
import {getPanelSpec, type PanelType} from '../../../util/panelTypes';
import {useFeatureFlagVegaEnabled} from '../../../util/useFeatureFlag';
import {usePanelContext} from '../PanelContextProvider';

export const useIsPanelEditButtonVisible = (
  entityName: string,
  panelType: PanelType
) => {
  const isMobileLayout = useIsMobile();
  const {isReadOnly} = usePanelContext();
  const panelSpec = useMemo(() => getPanelSpec(panelType), [panelType]);
  const vegaPanelEnabled = useFeatureFlagVegaEnabled(entityName);

  if (
    isReadOnly ||
    isMobileLayout ||
    panelSpec.noEditMode ||
    (panelType === 'Vega' && !vegaPanelEnabled)
  ) {
    return false;
  }

  return true;
};
